// Copyright (c) 2019-present Ithpower, Inc. All Rights Reserved.
// See LICENSE.txt for license information.
import React, {ReactNode} from 'react';
import {Tooltip} from 'antd';
import {TooltipPlacement} from 'antd/lib/tooltip';

require('utils/iconfont.js');
require('utils/icontype.js');

export interface IconProps {
    type: string,
    title?: ReactNode,
    titlePlacement?: TooltipPlacement,
    titleClassName?: string,
    className?: string,
    style?: React.CSSProperties,
    onMouseEnter?: () => void,
    onMouseLeave?: () => void,
    onFocus?: () => void,
    onClick?: React.MouseEventHandler<HTMLSpanElement>,
    id?: string,
    size?: number,
    color?: string,
    disable?: boolean,
}
export default class Icon extends React.PureComponent<IconProps> {
    static defaultProps = {
        className: '',
        style: {},
    };

    render() {
        const {
            className,
            onMouseEnter,
            onMouseLeave,
            onFocus,
            onClick,
            type,
            titlePlacement,
            title,
            titleClassName,
            size,
            color,
            style,
            disable,
        } = this.props;
        let containerClassName = 'iai-icon';
        if (disable) {
            containerClassName += ' disabled';
        } else if (onClick) {
            containerClassName += ' pointer-icon';
        }
        if (className) {
            containerClassName += ` ${className}`;
        }

        const extraStyle: any = {...style};
        if (size) {
            extraStyle.fontSize = size + 'px';
        }
        if (color) {
            extraStyle.color = color;
        }

        let context = (
            <svg aria-hidden='true'>
                <use xlinkHref={`#icon-${type}`}/>
            </svg>
        );
        if (title) {
            let placement: TooltipPlacement = 'top';
            if (titlePlacement) {
                placement = titlePlacement;
            }
            context = (
                <Tooltip
                    placement={placement}
                    arrowPointAtCenter={true}
                    title={title}
                    overlayClassName={titleClassName}
                >
                    {context}
                </Tooltip>
            );
        }

        return (
            <span
                id={this.props.id}
                className={containerClassName}
                style={extraStyle}
                onMouseEnter={onMouseEnter}
                onMouseLeave={onMouseLeave}
                onFocus={onFocus}
                onClick={onClick}
            >
                {context}
            </span>
        );
    }
}

export const IconWithHighlight: React.FC<IconProps> = ({className, ...props}) => {
    let highlightClass = 'highlight-icon';
    if (className) {
        highlightClass += ` ${className}`;
    }
    return (
        <Icon
            {...props}
            className={highlightClass}
        />
    );
};
